import { TxRecordsModel } from '@/services/apis/history/model'
import { useTranslation } from '@/services/i18n'
import { memo, useState } from 'react'
import TxRecordApi from '@/services/apis/history/TxRecords'
import editPng from '@/assets/images/inputIcon/bianji@2x.png'
import confirmPng from '@/assets/images/inputIcon/gou@2x.png'
import expandIcon from '@/assets/images/expandIcon.png'
import closePng from '@/assets/images/inputIcon/cha@2x.png'
import cls from 'classnames'
import styles from './index.module.scss'
import { Avatar, Input } from 'antd'
import AmlIcon from '@/assets/images/amlIcon.png'
import Warning from '@/assets/images/warning.png'

const Card = memo<{
  item: {
    name?: string
    isContract?: 0 | 1
    address?: string
    isAml?: 0 | 1
    type?: string
    value?: string | number
    unit?: string
    isPhishing?: 0 | 1
  }
}>(({ item }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.card}>
      <div className={styles.container}>
        <div className={styles.destContainer}>
          {item.type !== 'ONE_TIME_ADDRESS' && <div className={styles.text}> {item.name}</div>}
          {item.type === 'INTERNAL_WALLET' && (
            <div className={styles.tag}>{t('common.whiteList')}</div>
          )}
          {item.type === 'VAULT_ACCOUNT' && (
            <div className={styles.tag}>{t('record.vaultAccount')}</div>
          )}
        </div>
        <div className={styles.destContainer}>
          <div className={styles.address}> {item.address}</div>
          <div className={styles.destContainer}>
            <div className={styles.amount}>{item.value}</div>
            <div className={styles.unit} style={{ marginRight: '20px' }}>
              {item.unit}
            </div>
          </div>
        </div>
        {item.isAml === 1 && (
          <div style={{ color: '#e64646' }}>
            <img
              src={AmlIcon}
              style={{ height: '18px', width: '18px', marginRight: '4px' }}
              alt=""
            ></img>
            {t('record.aml')}
          </div>
        )}
        {item.isPhishing === 1 && (
          <div style={{ color: '#e64646' }}>
            <img
              src={Warning}
              style={{ height: '18px', width: '18px', marginRight: '4px' }}
              alt=""
            ></img>
            {t('record.fraudulentAddress')}
          </div>
        )}
      </div>
    </div>
  )
})
interface ChildPros {
  records: TxRecordsModel
}
const ExpandRow = memo<ChildPros>(props => {
  const { t } = useTranslation()
  const { records } = props
  const [editable, setEditable] = useState(false)
  const [note, setNote] = useState('')
  const [loading, setLoading] = useState(false)
  const [isExpand, setIsExpand] = useState(false)
  function edit() {
    setNote(records.note)
    setEditable(true)
  }
  async function submit() {
    setLoading(true)
    const res = await TxRecordApi.setNote(records.txKey, note)
    setLoading(false)
    if (res.success) {
      setEditable(false)
      records.note = note
    }
  }
  const [address, setAddress] = useState(records.destinationAddressList.slice(0, 3))
  function handleExpand() {
    setIsExpand(!isExpand)
    isExpand
      ? setAddress(records.destinationAddressList.slice(0, 3))
      : setAddress(records.destinationAddressList.slice(0, records.destinationAddressList.length))
  }

  const noCard =
    records.destinationAddressList.length === 1 && records.destinationType === 'ONE_TIME_ADDRESS'
  return (
    <div className={styles.expandContainer}>
      <div className={styles.leftBox}>
        <div className={styles.row}>
          <div className={styles.label}>Txn Hash:</div>
          {!records.exploreUrl ? (
            <div>{records.txHash}</div>
          ) : (
            <a target="_blank" href={records.exploreUrl} rel="noreferrer">
              {records.txHash}
            </a>
          )}
        </div>
        <div className={styles.toRow}>
          <div className={styles.label}>From {t('common.address')}:</div>
          <div>
            {records.sourceAddressList.map(item => {
              return (
                <div key={item.address}>
                  <div> {item.address}</div>
                  {
                    <div>
                      {item.isAml === 1 && (
                        <div style={{ color: '#e64646' }}>
                          <img
                            src={AmlIcon}
                            style={{ height: '18px', width: '18px', marginRight: '4px' }}
                            alt=""
                          ></img>
                          {t('record.aml')}
                        </div>
                      )}
                      {item.isPhishing === 1 && (
                        <div style={{ color: '#e64646' }}>
                          <img
                            src={Warning}
                            style={{ height: '18px', width: '18px', marginRight: '4px' }}
                            alt=""
                          ></img>
                          {t('record.fraudulentAddress')}
                        </div>
                      )}
                    </div>
                  }
                </div>
              )
            })}
          </div>
        </div>
        {!noCard ? (
          <div className={styles.toRow}>
            <div style={{ margin: '10px 0 0 0' }} className={styles.label}>
              To{t('common.address')}:
            </div>
            <div>
              {address.map(item => {
                return (
                  <Card
                    item={{
                      ...item,
                      type: records.realDestinationType,
                      name: records.destinationName,
                      unit: records.symbol,
                    }}
                  />
                )
              })}
              {records.destinationAddressList.length > 3 && (
                <div style={{ marginTop: '15px' }} onClick={handleExpand}>
                  <Avatar
                    src={expandIcon}
                    size={16}
                    className={cls({
                      [styles.icon]: true,
                      [styles.expand]: isExpand,
                    })}
                  />
                  {!isExpand ? t('common.expand') : t('common.retract')}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className={styles.toRow}>
            <div className={styles.label}>To{t('common.address')}:</div>
            <div>
              {records.destinationAddressList.map(item => {
                return (
                  <div key={item.address}>
                    <div> {item.address}</div>
                    {
                      <div>
                        {item.isAml === 1 && (
                          <div style={{ color: '#e64646' }}>
                            <img
                              src={AmlIcon}
                              style={{ height: '18px', width: '18px', marginRight: '4px' }}
                              alt=""
                            ></img>
                            {t('record.aml')}
                          </div>
                        )}
                        {item.isPhishing === 1 && (
                          <div style={{ color: '#e64646' }}>
                            <img
                              src={Warning}
                              style={{ height: '18px', width: '18px', marginRight: '4px' }}
                              alt=""
                            ></img>
                            {t('record.fraudulentAddress')}
                          </div>
                        )}
                      </div>
                    }
                  </div>
                )
              })}
            </div>
          </div>
        )}

        <div className={styles.row}>
          <div className={styles.label}>{t('common.network')}:</div>
          <div>{records.networkName}</div>
        </div>
        {/* Gas Fee */}
        {records.fee && (
          <div className={styles.row}>
            <div className={styles.label}>Gas Fee:</div>
            <div>
              {records.fee} <span style={{ marginLeft: '2px' }}> {records.feeSymbol}</span>($
              {records.feeToUsd})
            </div>
          </div>
        )}
      </div>
      <div style={{ width: '1px', backgroundColor: '#DEE2E2', margin: '0 85px ' }}></div>
      <div className={styles.rightBox}>
        <div className={styles.row}>
          <div className={styles.label}>{t('record.platformId')}:</div>
          <div style={{ maxWidth: '400px', wordBreak: 'break-all' }}>{records.txKey}</div>
        </div>
        <div className={styles.row}>
          {records.transactionStatus && (
            <div style={{ display: 'flex' }}>
              <div className={styles.label}>{t('record.subState')}:</div>
              <div>{records.transactionSubStatusDesc}</div>
            </div>
          )}
        </div>
        <div className={styles.row}>
          <div className={styles.label}>{t('record.transactionType')}:</div>
          <div>{records.transactionTypeDesc}</div>
        </div>
        <div className={styles.row}>
          <div className={styles.label}>{t('record.note')}: </div>
          {records.note && !editable && (
            <div style={{ wordBreak: 'break-all', maxWidth: '300px' }}>
              {records.note}
              <img
                src={editPng}
                alt=""
                className={styles.commonIcon}
                onClick={edit}
                style={{ marginLeft: '20px', height: '16px', width: '16px' }}
              />
            </div>
          )}
          {!records.note && !editable && (
            <div
              className={cls([styles.bold], [styles.desc])}
              style={{ fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: '#12b89a' }}
              onClick={() => setEditable(true)}
            >
              {t('common.add')}
            </div>
          )}
          {editable && (
            <div style={{ display: 'flex' }}>
              <Input
                style={{ height: '24px', width: '380px', marginRight: '5px' }}
                placeholder={t('record.notePlaceholder') as any}
                value={note}
                disabled={loading}
                onChange={e => setNote(e.target.value)}
              />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={closePng}
                  alt=""
                  className={styles.commonIcon}
                  onClick={() => setEditable(false)}
                  style={{ marginRight: '5px' }}
                />
                <img src={confirmPng} alt="" className={styles.commonIcon} onClick={submit} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
})

export default ExpandRow
